import { Status } from '@intellecteu/common-ui';
import { modes } from './modes';

export const statusServerConverter = (status: number | string | undefined) => {
  if (!status) return 'unknown';
  if (typeof status === 'number') {
    if (status < 200) return 'processing';
    if (status > 199 && status < 300) return 'success';
    if (status > 299 && status < 400) return 'processing';
    if (status > 399 && status < 500) return 'error';
    if (status > 499) return 'warning';
  }
  return status;
};

export const correctStatus = (status: string | undefined) => {
  const transformedStatus = typeof status === 'string' ? status.toLowerCase() : statusServerConverter(status);
  if (!transformedStatus) {
    return { ...Status.mode.unknown };
  }
  if (
    transformedStatus === 'pending' ||
    transformedStatus === 'waiting' ||
    transformedStatus === 'in_progress' ||
    transformedStatus === 'compensating'
  ) {
    return { ...Status.mode.processing };
  }

  if (transformedStatus === 'deleted') {
    return { ...Status.mode.info };
  }
  if (transformedStatus === 'terminating' || transformedStatus === 'recovering' || transformedStatus === 'canceled') {
    return { ...Status.mode.warning };
  }
  if (transformedStatus === 'running' || transformedStatus === 'completed' || transformedStatus === 'created') {
    return { ...Status.mode.success };
  }
  if (transformedStatus === 'failed') {
    return { ...Status.mode.error };
  }
  // TODO: will be added from ui-kit
  return modes[transformedStatus] ? Status.mode[transformedStatus] : Status.mode.unknown;
};
